import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ticket, ReceiptText, ShieldCheck, History, Store, LogOut, ChevronLeft, ChevronRight, Radio } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ITEMS = [
  { key: "issue", label: "Issue Token", icon: Ticket },
  { key: "subscribe", label: "Subscription", icon: ReceiptText },
  { key: "kyc", label: "KYC", icon: ShieldCheck },
  { key: "history", label: "History", icon: History },
  { key: "live", label: "Live Board", icon: Radio },
];
const TITLES = { issue: "Issue Token", subscribe: "Subscription", kyc: "KYC Verification", history: "Token History", live: "Live Board" };

export default function MerchantLayout({ active, onNav = () => {}, children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <header className="glass sticky top-0 z-40 border-b border-slate-800">
        <div className="relative flex items-center justify-between px-4 py-3 md:px-6">
          <div className="flex items-center gap-2.5">
            <img src="/paras-logo.png" alt="Paras CashBack" className="h-9 w-9 object-contain" />
            <div className="leading-none">
              <p className="font-heading text-sm font-bold">Paras CashBack</p>
              <p className="mt-0.5 flex items-center gap-1 font-mono text-[10px] uppercase tracking-widest text-emerald-400"><Store className="h-3 w-3" /> {TITLES[active] || "Merchant"}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden text-sm text-slate-400 sm:inline" data-testid="current-user-email">{user?.email}</span>
            <button data-testid="logout-button" onClick={doLogout} className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 px-3 py-1.5 text-sm transition hover:border-rose-500/50 hover:text-rose-300"><LogOut className="h-3.5 w-3.5" /> Logout</button>
          </div>
        </div>
      </header>

      <div className="mx-auto flex max-w-7xl">
        <aside data-testid="merchant-sidebar" className={`sticky top-[61px] hidden h-[calc(100vh-61px)] flex-shrink-0 flex-col border-r border-slate-800 p-3 transition-all duration-200 md:flex ${collapsed ? "w-16" : "w-60"}`}>
          <nav className="flex-1 space-y-1">
            {ITEMS.map((it) => {
              const A = active === it.key; const I = it.icon;
              return (
                <button key={it.key} data-testid={`tab-${it.key}`} onClick={() => onNav(it.key)} title={it.label}
                  className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition ${A ? "bg-emerald-500/15 text-emerald-400" : "text-slate-400 hover:bg-white/5 hover:text-white"}`}>
                  <I className="h-5 w-5 flex-shrink-0" />{!collapsed && <span className="flex-1 text-left">{it.label}</span>}
                </button>
              );
            })}
          </nav>
          <button data-testid="sidebar-collapse" onClick={() => setCollapsed((v) => !v)} aria-label="Collapse sidebar" className="mt-1 flex items-center justify-center rounded-xl px-3 py-2 text-slate-500 transition hover:text-white">
            {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
          </button>
        </aside>

        <main className="min-w-0 flex-1 px-4 py-6 pb-28 md:px-8 md:pb-10">{children}</main>
      </div>

      <nav data-testid="merchant-bottom-nav" className="glass fixed inset-x-0 bottom-0 z-50 border-t border-slate-800 pb-[env(safe-area-inset-bottom)] md:hidden">
        <div className="mx-auto grid max-w-md grid-cols-4">
          {ITEMS.map((it) => {
            const A = active === it.key; const I = it.icon;
            return (
              <button key={it.key} data-testid={`bottomnav-${it.key}`} onClick={() => { onNav(it.key); window.scrollTo({ top: 0, behavior: "smooth" }); }} className={`flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium ${A ? "text-emerald-400" : "text-slate-500"}`}>
                <I className="h-5 w-5" />{it.label}
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
